export function mapAccount(code) {
  switch (code) {
    case "030003":
    case "030037":
    case "030173":
    case "030012":
    case "030041":
    case "030194":
    case "030015":
    case "030039":
    case "030184":
    case "030024":
    case "030257":
    case "030274":
    case "030017":
    case "030058":
    case "030277":
    case "030086":
    case "030067":
    case "030284":
    case "030083":
    case "030239":
    case "030019":
    case "030276":
    case "030157":
    case "030210":
    case "030251":
    case "030232":
    case "030255":
    case "030259":
    case "030069":
    case "030285":
      return {
        agencia: "2590",
        conta: "356-8", 
        CNPJ: "61.602.199/0001-12"
      } 
    case "340004":
    case "340005":
    case "340007":
    case "340018":
    case "340034":
    case "340009":
    case "340041":
      return {
        agencia: "334", 
        conta: "40332-6", 
        CNPJ: "46.395.687/0001-02"
      }
    case "340015":
    case "340038":
    case "340011":
    case "340035":
    case "340043":
    case "340039":
    case "340052":
    case "340051":
    case "340054":
    case "340055":
      return {
        agencia: "478", 
        conta:  "45283-2", 
        CNPJ: "46.395.687/0001-02"
      }
    default:
      return null
  }
}
